module.exports = __webpack_public_path__ + "static/media/reclame-aqui.1d8264b7.png";